import React, { useEffect } from "react";
import ModeSelection from "../../components/Transportation/ModeSelection/ModeSelection";
import { useTripsCtx } from "../../context/TripDetailsContext";
import GoogleLoader from "../../assets/Loader/GoogleSvgLoader/GoogleLoader";

const ModeSelectionContainer = () => {
  const { isLoadingCostDetailsCtx } = useTripsCtx();

  return isLoadingCostDetailsCtx[0] ? <GoogleLoader /> : <ModeSelection />;
};
export default ModeSelectionContainer;
